const UAH = new Intl.NumberFormat('uk-UA', {
  style: 'currency',
  currency: 'UAH',
  maximumFractionDigits: 2,
})

const NUM = new Intl.NumberFormat('uk-UA')

const DATE = new Intl.DateTimeFormat('uk-UA', { dateStyle: 'medium' })
const DATETIME = new Intl.DateTimeFormat('uk-UA', { dateStyle: 'medium', timeStyle: 'short' })

export const money = (uah: number) => UAH.format(uah)
export const num = (value: number) => NUM.format(value)

export const date = (iso: string | null | undefined) => (iso ? DATE.format(new Date(iso)) : '—')
export const datetime = (iso: string | null | undefined) =>
  iso ? DATETIME.format(new Date(iso)) : '—'

/** "3 хв тому" — used in the live call log where absolute times add noise. */
export function relative(iso: string): string {
  const seconds = Math.round((Date.now() - new Date(iso).getTime()) / 1000)
  if (seconds < 60) return 'щойно'
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes} хв тому`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours} год тому`
  return date(iso)
}

/** Ukrainian plural rules — "1 запит / 2 запити / 5 запитів". */
export function plural(count: number, one: string, few: string, many: string): string {
  const mod10 = count % 10
  const mod100 = count % 100
  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few
  return many
}

/** Groups an IBAN into readable blocks of four without changing its value. */
export function prettyIban(iban: string): string {
  return iban.replace(/\s+/g, '').replace(/(.{4})/g, '$1 ').trim()
}

export function shortenMiddle(value: string, head = 14, tail = 6): string {
  if (value.length <= head + tail + 1) return value
  return `${value.slice(0, head)}…${value.slice(-tail)}`
}

export async function copy(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}

export function downloadBlob(content: BlobPart, filename: string, mime: string) {
  const url = URL.createObjectURL(new Blob([content], { type: mime }))
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  // Revoking immediately can cancel the download in Safari; one tick is enough.
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export function dataUrlToBlob(dataUrl: string): Blob {
  const [meta, b64] = dataUrl.split(',')
  const mime = meta.match(/:(.*?);/)?.[1] ?? 'application/octet-stream'
  const bytes = atob(b64)
  const buffer = new Uint8Array(bytes.length)
  for (let i = 0; i < bytes.length; i++) buffer[i] = bytes.charCodeAt(i)
  return new Blob([buffer], { type: mime })
}
